import React from 'react';
import { MdConstruction } from 'react-icons/md';

function Nft() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
      <MdConstruction className="text-6xl text-yellow-500 mb-4" />
      <h2 className="text-2xl md:text-4xl font-bold mb-2 text-gray-800">Feature Under Development</h2>
      <p className="text-lg md:text-xl text-gray-600 text-center max-w-lg">
        We're working hard to bring you this feature. Stay tuned for updates!
      </p>
     
    </div>
  );
}

export default Nft;
